import { Button } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { showError } from '../../constants/toasts';
import MainContainer from '../../layout/MainContainer';
import { useLazyGetStoreByIdQuery } from '../../service/store';
import { Store } from '../../types/General';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const DealerStoreDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  // const [getDetail] = useLazyGetUserByIdQuery();
  const [loading, setLoading] = useState(false);
  const [details, setUserDetails] = useState();
  const [getStore] = useLazyGetStoreByIdQuery();
  const [store, setStore] = useState<Store>();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal4, setOpenModal4] = useState(false);
  const handleCloseModal4 = () => {
    setOpenModal4(false);
  };

  const getStoreData = async () => {
    setLoading(true);
    try {
      const response = await getStore({ id: id as string }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setStore(response?.data || []);
      } else {
        //  setStore({});
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  useEffect(() => {
    getStoreData();
  }, []);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>Store Detail</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Registrations - Store
            Detail
          </p>
        </div>

        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <div className="profileInfo_head">
          <h2>Personal Detail</h2>
        </div>

        <div className="profileInfo_list">
          <ul className="text_info gap_p">
            <li className="w_50">
              <strong>User Id</strong>
              <span>#CR1987876</span>
            </li>
            <li className="w_50">
              <strong>User Type</strong>
              <span>Dealer</span>
            </li>
            <li className="w_50">
              <strong>Name</strong>
              <span>{store?.user?.name || '-'}</span>
            </li>
            <li className="w_50">
              <strong>E-mail</strong>
              <span>{store?.user?.email || '-'}</span>
            </li>
            <li className="w_50">
              <strong>Phone</strong>
              <span>
                {store?.user?.dialCode} {store?.user?.phoneNo || '-'}
              </span>
            </li>

            <li className="w_50">
              <strong>Store Name</strong>
              <span>{store?.storeName || '-'}</span>
            </li>
            {store?.openingTime ? (
              <li className="w_50">
                <strong>Store Opening Time</strong>
                <span>{moment(store?.openingTime).format('LT')}</span>
              </li>
            ) : null}
            {store?.closingTime ? (
              <li className="w_50">
                <strong>Store Closing Time</strong>
                <span>{moment(store?.closingTime).format('LT')}</span>
              </li>
            ) : null}

            <li className="w_50">
              <strong>Address</strong>
              <span>{store?.addressObject?.address || '-'}</span>
            </li>
            <li className="w_50">
              <strong>City</strong>
              <span>{store?.addressObject?.city || '-'}</span>
            </li>
            <li className="w_50">
              <strong>Pin Code</strong>
              <span>{store?.addressObject?.pincode || '-'}</span>
            </li>
          </ul>
          {store?.bankDetails?.bankName && (
            <div className="gap_p">
              <div className="w_50">
                <h3>Bank Account Details</h3>
                <ul className="text_info gap_p">
                  <li>
                    <strong>Bank Name</strong>
                    <span>{store?.bankDetails?.bankName || '-'}</span>
                  </li>
                  <li>
                    <strong>Account Holder Name</strong>
                    <span>{store?.bankDetails?.accountHolederName || '-'}</span>
                  </li>
                  <li>
                    <strong>Branch Name</strong>
                    <span>{store?.bankDetails?.branchName || '-'}</span>
                  </li>
                  <li>
                    <strong>Bank Code</strong>
                    <span>{store?.bankDetails?.bankCode || '-'}</span>
                  </li>
                </ul>
              </div>

              {/* <div className="w_50">
                   <h3>Payment Procedure Information _Upon Delivery (100%)</h3>
                   <ul className="text_info gap_p">
                     <li>
                       <strong>Currency</strong>
                       <span>Currey of departure</span>
                     </li>
                     <li>
                       <strong>Bank Name</strong>
                       <span>Al Rajhi Bank</span>
                     </li>
                     <li>
                       <strong>Account Holder Name</strong>
                       <span>Naief Osman</span>
                     </li>
                     <li>
                       <strong>Bank Name</strong>
                       <span>1523-4628-4297-9953</span>
                     </li>
                   </ul>
                 </div> */}
            </div>
          )}
        </div>
        {/* 
             <div className="shipping_img">
               <h3>Shipping Pictures</h3>
               <ul>
                 <li>
                   <figure onClick={() => setOpenModal4(true)}>
                     <img src="/static/images/shipping_01.jpg" alt="Shipping" />
                   </figure>
                 </li>
                 <li>
                   <figure onClick={() => setOpenModal4(true)}>
                     <img src="/static/images/shipping_02.jpg" alt="Shipping" />
                   </figure>
                 </li>
                 <li>
                   <figure onClick={() => setOpenModal4(true)}>
                     <img src="/static/images/shipping_03.jpg" alt="Shipping" />
                   </figure>
                 </li>
                 <li>
                   <figure onClick={() => setOpenModal4(true)}>
                     <img src="/static/images/shipping_04.jpg" alt="Shipping" />
                   </figure>
                 </li>
               </ul>
       
               <TableContainer className="table_container">
                 <Box className="heading"></Box>
                 <Table className="v2" aria-label="simple table">
                   <TableHead>
                     <TableRow>
                       <TableCell>#</TableCell>
                       <TableCell>Shipping Customers</TableCell>
                       <TableCell>Customer comment</TableCell>
                       <TableCell>Delivery Home</TableCell>
                       <TableCell>Packaging service</TableCell>
                       <TableCell>Shipping</TableCell>
                       <TableCell>Quantity</TableCell>
                       <TableCell>Shipping cost</TableCell>
                     </TableRow>
                   </TableHead>
                   <TableBody>
                     <TableRow>
                       <TableCell>1</TableCell>
                       <TableCell>
                         <div className="user_block">
                           <figure>
                             <img src="/static/images/user_attachment.jpg" alt="" />
                           </figure>
                           <p>
                             <b>Riyadh</b> +9203024595467
                           </p>
                         </div>
                       </TableCell>
                       <TableCell>
                         <p className="view_link" onClick={() => setOpenModal3(true)}>
                           Comment{" "}
                           <img src="/static/images/external_icon.svg" alt="Icon" />
                         </p>
                       </TableCell>
                       <TableCell>No</TableCell>
                       <TableCell>Yes</TableCell>
                       <TableCell>
                         <figure className="icon_text">
                           <img src="/static/images/briefcase_icon.svg" alt="Icon" />
                           <figcaption>Suit Case</figcaption>
                         </figure>
                       </TableCell>
                       <TableCell>25</TableCell>
                       <TableCell>40$</TableCell>
                     </TableRow>
                     <TableRow>
                       <TableCell>1</TableCell>
                       <TableCell>
                         <div className="user_block">
                           <figure>
                             <img src="/static/images/user_attachment.jpg" alt="" />
                           </figure>
                           <p>
                             <b>Riyadh</b> +9203024595467
                           </p>
                         </div>
                       </TableCell>
                       <TableCell>
                         <p className="view_link" onClick={() => setOpenModal3(true)}>
                           Comment{" "}
                           <img src="/static/images/external_icon.svg" alt="Icon" />
                         </p>
                       </TableCell>
                       <TableCell>No</TableCell>
                       <TableCell>Yes</TableCell>
                       <TableCell>
                         <figure className="icon_text">
                           <img src="/static/images/briefcase_icon.svg" alt="Icon" />
                           <figcaption>Suit Case</figcaption>
                         </figure>
                       </TableCell>
                       <TableCell>25</TableCell>
                       <TableCell>40$</TableCell>
                     </TableRow>
                   </TableBody>
                 </Table>
               </TableContainer>
             </div> */}

        {/* <PassportResidenceModal
               open={openModal1}
               onClose={handleCloseModal1}
               setOpen={setOpenModal1}
             />
             <VehicleRegistrationModal
               open={openModal2}
               onClose={handleCloseModal2}
               setOpen={setOpenModal2}
             />
             <ViewComment
               open={openModal3}
               onClose={handleCloseModal3}
               setOpen={setOpenModal3}
             /> */}
        {/* <ShippingGallery
               open={openModal4}
               onClose={handleCloseModal4}
               setOpen={setOpenModal4}
             /> */}
      </div>
    </MainContainer>
  );
};

export default DealerStoreDetail;
